import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useModal } from 'core';
import { BrgButton, ButtonVariant } from '@brg/ui';
import styled from 'styled-components';
import CloseIcon from 'shared/icons/CloseIcon';

export type LessonDeleteMode = 'single' | 'future' | 'all';

export interface LessonDeleteModalProps {
    themeName?: string;
    dateLabel: string;
    dayOfWeekLabel: string;
    timeRange: string;
    onDelete: (mode: LessonDeleteMode) => void;
}

const ModalWrapper = styled.div`
    background: #ffffff;
    border-radius: 8px;
    width: 480px;
    max-width: calc(100vw - 32px);
    padding: 32px;
    display: flex;
    flex-direction: column;
    gap: 24px;
`;

const ModalHeaderRow = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 16px;
`;

const ModalTitle = styled.div`
    font-family: Inter;
    font-size: 22px;
    font-weight: 600;
    line-height: 28px;
    letter-spacing: -0.44px;
    color: #151514;
`;

const ModalSubtitle = styled.div`
    font-family: Inter;
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    color: #909090;
    margin-top: -16px;
`;

const ModalCloseBtn = styled.button`
    background: none;
    border: none;
    cursor: pointer;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    color: #151514;
    opacity: 0.5;
    transition: opacity 0.2s;
    &:hover { opacity: 1; }
`;

const RadioGroup = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
`;

const RadioLabel = styled.label`
    display: flex;
    align-items: flex-start;
    gap: 10px;
    cursor: pointer;
    font-family: Inter;
    font-size: 15px;
    font-weight: 400;
    line-height: 20px;
    color: #151514;

    input[type='radio'] {
        margin-top: 2px;
        flex-shrink: 0;
        width: 18px;
        height: 18px;
        accent-color: #151514;
        cursor: pointer;
    }
`;

const ButtonRow = styled.div`
    display: flex;
    gap: 12px;

    > * {
        flex: 1;
    }
`;

export const LessonDeleteModal: FC<LessonDeleteModalProps> = ({
    themeName,
    dateLabel,
    dayOfWeekLabel,
    timeRange,
    onDelete,
}) => {
    const { t } = useTranslation();
    const modal = useModal();
    const [mode, setMode] = useState<LessonDeleteMode>('single');

    const handleDelete = () => {
        onDelete(mode);
        modal.hide();
    };

    const hasSubtitle = Boolean(themeName || dateLabel);

    return (
        <ModalWrapper>
            <ModalHeaderRow>
                <ModalTitle>{t('lms.lessonDeleteModal.title')}</ModalTitle>
                <ModalCloseBtn onClick={() => modal.hide()} aria-label="close">
                    <CloseIcon fill="currentColor" />
                </ModalCloseBtn>
            </ModalHeaderRow>

            {hasSubtitle && (
                <ModalSubtitle>
                    {themeName && <>{themeName}<br /></>}
                    {dateLabel}, {dayOfWeekLabel}, {timeRange}
                </ModalSubtitle>
            )}

            <RadioGroup>
                <RadioLabel>
                    <input
                        type="radio"
                        name="delete-mode"
                        checked={mode === 'single'}
                        onChange={() => setMode('single')}
                    />
                    <span>{t('lms.lessonDeleteModal.optionSingle')}</span>
                </RadioLabel>
                <RadioLabel>
                    <input
                        type="radio"
                        name="delete-mode"
                        checked={mode === 'future'}
                        onChange={() => setMode('future')}
                    />
                    <span>
                        {t('lms.lessonDeleteModal.optionFuture', { day: dayOfWeekLabel, time: timeRange })}
                    </span>
                </RadioLabel>
                <RadioLabel>
                    <input
                        type="radio"
                        name="delete-mode"
                        checked={mode === 'all'}
                        onChange={() => setMode('all')}
                    />
                    <span>
                        {t('lms.lessonDeleteModal.optionAll', { day: dayOfWeekLabel, time: timeRange })}
                    </span>
                </RadioLabel>
            </RadioGroup>

            <ButtonRow>
                <BrgButton variant={ButtonVariant.Hollow} onClick={() => modal.hide()}>
                    {t('lms.lessonDeleteModal.cancel')}
                </BrgButton>
                <BrgButton onClick={handleDelete}>
                    {t('lms.lessonDeleteModal.delete')}
                </BrgButton>
            </ButtonRow>
        </ModalWrapper>
    );
};
import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useModal } from 'core';
import { BrgButton, ButtonVariant } from '@brg/ui';
import styled from 'styled-components';
import CloseIcon from 'shared/icons/CloseIcon';

export type LessonDeleteMode = 'single' | 'future' | 'all';

export interface LessonDeleteModalProps {
    themeName?: string;
    dateLabel: string;
    dayOfWeekLabel: string;
    timeRange: string;
    onDelete: (mode: LessonDeleteMode) => void;
}

const ModalWrapper = styled.div`
    background: #ffffff;
    border-radius: 8px;
    width: 480px;
    max-width: calc(100vw - 32px);
    padding: 32px;
    display: flex;
    flex-direction: column;
    gap: 24px;
`;

const ModalHeaderRow = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 16px;
`;

const ModalTitle = styled.div`
    font-family: Inter;
    font-size: 22px;
    font-weight: 600;
    line-height: 28px;
    letter-spacing: -0.44px;
    color: #151514;
`;

const ModalSubtitle = styled.div`
    font-family: Inter;
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    color: #909090;
    margin-top: -16px;
`;

const ModalCloseBtn = styled.button`
    background: none;
    border: none;
    cursor: pointer;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    color: #151514;
    opacity: 0.5;
    transition: opacity 0.2s;
    &:hover { opacity: 1; }
`;

const RadioGroup = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
`;

const RadioLabel = styled.label`
    display: flex;
    align-items: flex-start;
    gap: 10px;
    cursor: pointer;
    font-family: Inter;
    font-size: 15px;
    font-weight: 400;
    line-height: 20px;
    color: #151514;

    input[type='radio'] {
        margin-top: 2px;
        flex-shrink: 0;
        width: 18px;
        height: 18px;
        accent-color: #151514;
        cursor: pointer;
    }
`;

const ButtonRow = styled.div`
    display: flex;
    gap: 12px;

    > * {
        flex: 1;
    }
`;

export const LessonDeleteModal: FC<LessonDeleteModalProps> = ({
    themeName,
    dateLabel,
    dayOfWeekLabel,
    timeRange,
    onDelete,
}) => {
    const { t } = useTranslation();
    const modal = useModal();
    const [mode, setMode] = useState<LessonDeleteMode>('single');

    const handleDelete = () => {
        onDelete(mode);
        modal.hide();
    };

    const hasSubtitle = Boolean(themeName || dateLabel);

    return (
        <ModalWrapper>
            <ModalHeaderRow>
                <ModalTitle>{t('lms.lessonDeleteModal.title')}</ModalTitle>
                <ModalCloseBtn onClick={() => modal.hide()} aria-label="close">
                    <CloseIcon fill="currentColor" />
                </ModalCloseBtn>
            </ModalHeaderRow>

            {hasSubtitle && (
                <ModalSubtitle>
                    {themeName && <>{themeName}<br /></>}
                    {dateLabel}, {dayOfWeekLabel}, {timeRange}
                </ModalSubtitle>
            )}

            <RadioGroup>
                <RadioLabel>
                    <input
                        type="radio"
                        name="delete-mode"
                        checked={mode === 'single'}
                        onChange={() => setMode('single')}
                    />
                    <span>{t('lms.lessonDeleteModal.optionSingle')}</span>
                </RadioLabel>
                <RadioLabel>
                    <input
                        type="radio"
                        name="delete-mode"
                        checked={mode === 'future'}
                        onChange={() => setMode('future')}
                    />
                    <span>
                        {t('lms.lessonDeleteModal.optionFuture', { day: dayOfWeekLabel, time: timeRange })}
                    </span>
                </RadioLabel>
                <RadioLabel>
                    <input
                        type="radio"
                        name="delete-mode"
                        checked={mode === 'all'}
                        onChange={() => setMode('all')}
                    />
                    <span>
                        {t('lms.lessonDeleteModal.optionAll', { day: dayOfWeekLabel, time: timeRange })}
                    </span>
                </RadioLabel>
            </RadioGroup>

            <ButtonRow>
                <BrgButton variant={ButtonVariant.Hollow} onClick={() => modal.hide()}>
                    {t('lms.lessonDeleteModal.cancel')}
                </BrgButton>
                <BrgButton onClick={handleDelete}>
                    {t('lms.lessonDeleteModal.delete')}
                </BrgButton>
            </ButtonRow>
        </ModalWrapper>
    );
};
